const api = {
  //  baseURL: "http://localhost:4012",
  baseURL: "https://admin-shopping-dev.tsa-auto.com/",
  // baseURL: "https://admin-shopping.tsa-auto.com/",
};
export default api;
